import { useState } from 'react'
import { graphql } from 'app/generated/gql'
import { gqlMutation } from 'app/lib/graphqlClient'
import { opsClient } from 'app/lib/opsUrqlClient'

const CACHE_SEARCH_MUTATION = graphql(`
  mutation CacheSearch($pattern: String!) {
    cacheSearch(pattern: $pattern)
  }
`)

const CACHE_DELETE_MUTATION = graphql(`
  mutation CacheDelete($pattern: String!) {
    cacheDelete(pattern: $pattern)
  }
`)

export type CacheSearchResult = {
  key: string
  value: string
  ttl: number
}

export type UseOpsCacheReturn = {
  connected: boolean
  connError?: string
  searchPattern: string
  setSearchPattern: (v: string) => void
  deletePattern: string
  setDeletePattern: (v: string) => void
  showDeleteConfirm: boolean
  setShowDeleteConfirm: (v: boolean) => void
  isSearching: boolean
  isDeleting: boolean
  searchData: any
  deleteData: any
  onSearch: () => void
  onDelete: () => void
}

export function useOpsCache(): UseOpsCacheReturn {
  const [searchPattern, setSearchPattern] = useState(``)
  const [deletePattern, setDeletePattern] = useState(``)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [searchData, setSearchData] = useState<any>()
  const [deleteData, setDeleteData] = useState<any>()

  const onSearch = () => {
    if (searchPattern.trim()) {
      setIsSearching(true)
      gqlMutation(CACHE_SEARCH_MUTATION, { pattern: searchPattern.trim() }, { client: opsClient })
        .then((result) => setSearchData(result.data?.cacheSearch))
        .finally(() => setIsSearching(false))
    }
  }

  const onDelete = () => {
    if (deletePattern.trim()) {
      setIsDeleting(true)
      gqlMutation(CACHE_DELETE_MUTATION, { pattern: deletePattern.trim() }, { client: opsClient })
        .then((result) => setDeleteData(result.data?.cacheDelete))
        .finally(() => {
          setIsDeleting(false)
          setShowDeleteConfirm(false)
        })
    }
  }

  return {
    connected: true,
    searchPattern,
    setSearchPattern,
    deletePattern,
    setDeletePattern,
    showDeleteConfirm,
    setShowDeleteConfirm,
    isSearching,
    isDeleting,
    searchData,
    deleteData,
    onSearch,
    onDelete,
  }
}
